<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.66662 1.33301L2.72892 8.45824C2.49638 8.73729 2.38011 8.87681 2.37833 8.99465C2.37679 9.09709 2.42244 9.19454 2.50212 9.25894C2.59378 9.33301 2.7754 9.33301 3.13864 9.33301H7.99995L7.33328 14.6663L13.271 7.54111C13.5035 7.26206 13.6198 7.12254 13.6216 7.0047C13.6231 6.90226 13.5775 6.8048 13.4978 6.74041C13.4061 6.66634 13.2245 6.66634 12.8613 6.66634H7.99995L8.66662 1.33301Z"
      stroke="currentColor"
      stroke-width="1.28"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
